import { confirm } from 'cadenza/alert';
import { getStore } from 'cadenza/store/cadenza-store';
import { setupAjaxForDevelopmentVersion } from 'cadenza/workbook-ajax-setup';
import { executeSaveWorkbook } from 'cadenza/workbook/header/save-workbook-actions/save-workbook-actions';
import { getWorkbookId, isWorkbookPublished } from 'cadenza/workbook/workbook-core-selectors.state';

import i18n from './confirm-save-published-workbook.properties';

// Wraps a function with a confirm dialog that will be shown only if the workbook is in a published
// state, forcing saving of the workbook before executing the function. This avoids users from
// performing actions on an OT in a published workbook and not seeing the results (since the
//  modifications would be added to a new draft version of the OT and that will only be shown in a
//  new draft version of the workbook -this way, with the saving, we create a new draft version of
//  the workbook that will automatically show the new OT with its latest modification).
export async function confirmSavePublishedWorkbookBeforeAction() {
  if (isWorkbookPublished(getStore().getState())) {
    const confirmation = await showConfirmSaveAndExecuteDialog();
    if (confirmation) {
      await executeSaveWorkbook();
      setupAjaxForDevelopmentVersion(getWorkbookId(getStore().getState()));
    }
    return confirmation;
  } else {
    return true;
  }
}

export function showConfirmSaveAndExecuteDialog() {
  return confirm(i18n('confirm.save.workbook.title'), '', {
    cancel: true,
    submit: i18n('confirm.save.workbook.submit'),
  });
}
